// The new Ask Addy's name and picture for each organization, remembered in the browser so the
// sidebar shows them straight away instead of a fallback name until the default agent loads.
const CACHE_KEY = "askAddyV2Assistant";

const readAll = () => {
  try {
    return JSON.parse(window.localStorage.getItem(CACHE_KEY) || "{}") || {};
  } catch {
    return {};
  }
};

/** `{ name, imageUrl }` from the organization's last visit, or null. */
export const readCachedAssistant = (organizationId) => (organizationId ? readAll()[organizationId] || null : null);

export const cacheAssistant = (organizationId, assistant) => {
  if (!organizationId) {
    return;
  }

  try {
    window.localStorage.setItem(CACHE_KEY, JSON.stringify({ ...readAll(), [organizationId]: assistant }));
  } catch {
    // Storage blocked: the name still shows once the default agent loads.
  }
};
